(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/matchstatistics/assets/javascripts/views/statformlatestmatches.js') >= 0) return;  svs.modules.push('/components/statistics/matchstatistics/assets/javascripts/views/statformlatestmatches.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatFormLatestMatches = Backbone.View.extend({
    tagName: 'div',
    classId: 'StatFormLatestMatches',
    viewId: 'statistik',
    events: {
      'change #latestMatchesTableFilter': 'selectMenu',
      'change #latestMatchesHomeAwayFilter': 'selectMenu'
    },
    matchNoFilter: 5,
    matchHomeAwayFilter: 'all',
    numOfMatches: 5,

    initialize: function(options) {
      this.modelReference = options.modelReference;
      this.options = options.options;
      this.filters = this.getFilters();
    },
    update: function(model) {
      this.modelReference = model;
      this.render({});
    },

    getFilters: function() {
      var filters = {
        latestMatchesTableFilter: {
          filterValues: {},
          selectedKey: '',
          showDropDown: true
        },
        latestMatchesHomeAwayFilter: {
          filterValues: {},
          selectedKey: 'all'
        }
      };
      return filters;
    },

    render: function() {
      if (!_.isObject(this.modelReference.get('statistics'))) return this;

      var statistics = this.modelReference.get('statistics');
      if (!_.isObject(statistics.sport)) {
        return this;
      }

      var id = statistics.sport.id;
      var _self = this,
        componentFile = 'stat-form-latest-matches',
        theme;
      theme = new svs.sport.themeLoader({
        sport: id
      });
      theme.load(function(template, init) {
        if (!template) {
          return _self;
        }
        _self.template = template;

        _self.$el.html(_self.template(_self.applyFilters()));

        if (
          Object.prototype.hasOwnProperty.call(_self.options.params, 'parent')
        ) {
          _self.options.params.parent.trigger('resize');
        }
        if (init) {
          init(componentFile);
        }
      }, componentFile);
      return this;
    },
    getTemplateFunction: function(func, data) {
      var returner = false,
        theme;
      theme = new svs.sport.themeLoader({
        sport: data.sport.id
      });
      theme.load(function(template, init) {
        if (init) {
          returner = init(func, data);
        }
      }, 'init');
      return returner;
    },
    selectMenu: function(event) {
      var selected = $(event.currentTarget);
      var selectedVal = selected.val();
      var callOptions = {};

      if (svs.core.detect.formfactor.mobile()) {
        selected.trigger('blur');
      }

      this.filters[$(event.currentTarget).attr('id')].selectedKey = selectedVal;
      var me = this;
      _.each(
        this.filters[$(event.currentTarget).attr('id')].filterValues,
        function(filterValue) {
          filterValue.selected = false;
          me.filters[$(event.currentTarget).attr('id')].filterValues[
            selectedVal
          ].selected = true;
        }
      );

      if ($(event.currentTarget).attr('id') === 'latestMatchesTableFilter') {
        this.matchNoFilter = selectedVal;
        this.numOfMatches = this.filters[
          $(event.currentTarget).attr('id')
        ].filterValues[selectedVal].numOfMatches;
        callOptions.selection = this.matchHomeAwayFilter;

        if (callOptions.selection === 'all') {
          callOptions.selection = '';
        }

        this.modelReference.updateFormLatest(callOptions);
      }

      if ($(event.currentTarget).attr('id') === 'latestMatchesHomeAwayFilter') {
        this.matchHomeAwayFilter = selectedVal;
        callOptions.selection = this.matchHomeAwayFilter;

        if (callOptions.selection === 'all') {
          callOptions.selection = '';
        }

        this.modelReference.updateFormLatest(callOptions);
      }

      if (svs.core.detect.formfactor.mobile()) {
        $(window.document).trigger('resizeTabView');
      }
    },
    applyFilters: function() {
      var self = this,
        statistics = this.modelReference.get('statistics'),
        latestMatchesHome,
        latestMatchesAway;

      var getLatestMatchesHomeAwayFilter = this.getTemplateFunction(
        'getLatestMatchesHomeAwayFilter',
        statistics
      );
      this.filters.latestMatchesHomeAwayFilter.filterValues = getLatestMatchesHomeAwayFilter;

      if (statistics) {
        if (_.isObject(statistics.latestMatches)) {
          if (
            _.isObject(statistics.latestMatches.home) &&
            _.isObject(statistics.latestMatches.away)
          ) {
            var homeMatches =
              statistics.latestMatches.home[
                self.filters.latestMatchesHomeAwayFilter.selectedKey
              ];
            var awayMatches =
              statistics.latestMatches.away[
                self.filters.latestMatchesHomeAwayFilter.selectedKey
              ];

            if (homeMatches.length <= 3 && awayMatches.length <= 3) {
              self.filters.latestMatchesTableFilter.showDropDown = false;
            } else {
              var latestMatches =
                homeMatches.length >= awayMatches.length
                  ? homeMatches
                  : awayMatches;
              for (var i = 0; i < latestMatches.length - 2; i++) {
                self.filters.latestMatchesTableFilter.filterValues[i] = {
                  name: 'Matcher (' + (latestMatches.length - i) + ')',
                  selected: false,
                  numOfMatches: latestMatches.length - i
                };
              }
              if (!self.inited) {
                self.inited = true;
                self.matchNoFilter = latestMatches.length - 5;
                if (self.matchNoFilter < 0) self.matchNoFilter = 0;
              }
            }
          }
        }
      }
      this.filters.latestMatchesTableFilter.filterValues =
        this.filters.latestMatchesTableFilter.filterValues || {};
      _.each(this.filters.latestMatchesTableFilter.filterValues, function(
        filterValue
      ) {
        filterValue.selected = false;
        self.filters.latestMatchesTableFilter.filterValues[
          self.matchNoFilter
        ].selected = true;
      });

      _.each(this.filters.latestMatchesHomeAwayFilter.filterValues, function(
        filterValue
      ) {
        filterValue.selected = false;
        self.filters.latestMatchesHomeAwayFilter.filterValues[
          self.matchHomeAwayFilter
        ].selected = true;
      });

      var oLatestMatches = this.getLatestMatchesObject();
      statistics = oLatestMatches.statistics;
      latestMatchesHome = oLatestMatches.latestMatchesHome;
      latestMatchesAway = oLatestMatches.latestMatchesAway;

      if (!latestMatchesHome) {
        latestMatchesHome = {};
      }
      if (!latestMatchesAway) {
        latestMatchesAway = {};
      }

      return {
        statistics: statistics,
        latestMatchesHome: latestMatchesHome,
        latestMatchesAway: latestMatchesAway,
        filters: this.filters
      };
    },
    getLatestMatchesObject: function() {
      var statistics = this.modelReference.get('statistics'),
        self = this,
        homeTeamMatches,
        awayTeamMatches;

      if (statistics) {
        if (_.isObject(statistics.latestMatches)) {
          if (
            _.isObject(statistics.latestMatches.home) &&
            _.isObject(statistics.latestMatches.away)
          ) {
            var homeMatchLatest = [];
            var awayMatchLatest = [];
            var homeMatchTrend = null;
            var awayMatchTrend = null;
            var allMatches = [];
            var currentHomeTeamId = self.modelReference.homeTeam.id;
            var currentAwayTeamId = self.modelReference.awayTeam.id;
            var homeNumGoalsPerMatchfor;
            var awayNumGoalsPerMatchfor;

            homeTeamMatches = JSON.parse(
              JSON.stringify(
                _.first(
                  statistics.latestMatches.home[
                    self.filters.latestMatchesHomeAwayFilter.selectedKey
                  ],
                  self.numOfMatches
                )
              )
            );
            awayTeamMatches = JSON.parse(
              JSON.stringify(
                _.first(
                  statistics.latestMatches.away[
                    self.filters.latestMatchesHomeAwayFilter.selectedKey
                  ],
                  self.numOfMatches
                )
              )
            );

            allMatches.push(homeTeamMatches);
            allMatches.push(awayTeamMatches);

            for (var i = 0; i < 2; i++) {
              var match = {};
              match.result = allMatches[i];
              var history = svs.utils.result.getLatestAndTrend(
                match,
                i,
                currentHomeTeamId,
                currentAwayTeamId
              );

              if (i === 0) {
                homeMatchLatest = history.latest;
                homeMatchTrend = svs.utils.result.getCurrentTrend(
                  history.trend
                );
                homeNumGoalsPerMatchfor = history.numGoalsPerMatchFor;
              } else {
                awayMatchLatest = history.latest;
                awayMatchTrend = svs.utils.result.getCurrentTrend(
                  history.trend
                );
                awayNumGoalsPerMatchfor = history.numGoalsPerMatchFor;
              }
            }

            homeTeamMatches.forEach(function(match) {
              if (
                svs.utils.ns.isNamespace('match.homeTeam', match) &&
                svs.utils.ns.isNamespace('match.awayTeam', match) &&
                svs.utils.ns.isNamespace('match.result.home', match) &&
                svs.utils.ns.isNamespace('match.result.away', match)
              ) {
                match.match.homeTeam.result = match.match.result.home;
                match.match.awayTeam.result = match.match.result.away;
              }
            });

            awayTeamMatches.forEach(function(match) {
              if (
                svs.utils.ns.isNamespace('match.homeTeam', match) &&
                svs.utils.ns.isNamespace('match.awayTeam', match) &&
                svs.utils.ns.isNamespace('match.result.home', match) &&
                svs.utils.ns.isNamespace('match.result.away', match)
              ) {
                match.match.homeTeam.result = match.match.result.home;
                match.match.awayTeam.result = match.match.result.away;
              }
            });

            if (homeNumGoalsPerMatchfor) {
              homeTeamMatches.numGoalsPerMatchFor = (
                homeNumGoalsPerMatchfor / this.numOfMatches
              )
                .toFixed(2)
                .replace('.', ',');
            }
            if (awayNumGoalsPerMatchfor) {
              awayTeamMatches.numGoalsPerMatchFor = (
                awayNumGoalsPerMatchfor / this.numOfMatches
              )
                .toFixed(2)
                .replace('.', ',');
            }

            statistics.participants = [
              { latest: homeMatchLatest, trend: homeMatchTrend },
              { latest: awayMatchLatest, trend: awayMatchTrend }
            ];
          }
        }
      }
      return {
        statistics: statistics,
        latestMatchesHome: homeTeamMatches,
        latestMatchesAway: awayTeamMatches
      };
    },

    onDestroy: function() {
      this.undelegateEvents();
      this.modelReference.off();

      delete this.options.params.parent;
      delete this.$el;
      delete this.el;
    }
  });
})(Backbone, _, svs);

 })(window);